import {
    FetchState,
    RoleState, RoleType,
    UserRoleModel
} from "@/shared/types";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";
import { getRolesByType } from "@/shared/api/userService";

export const initialState: RoleState = {
    partnerRolesFetchState: FetchState.Uninitialized,
    partnerRoles: [],
    employerRolesFetchState: FetchState.Uninitialized,
    employerRoles: []
};

export const useRoleStore = defineStore("role", {
    persist: {
        storage: localStorage,
        paths: storeHelper.getStoragePaths("role"),
    },
    state: () => (_.cloneDeep(initialState)),
    getters: {
        hasPartnerRoles: state => state.partnerRoles.length > 0,
        hasEmployerRoles: state => state.employerRoles.length > 0,
    },
    actions: {
        setPartnerRolesFetchState (fetchState: FetchState) {
            this.partnerRolesFetchState = fetchState;
        },
        setEmployerRolesFetchState (fetchState: FetchState) {
            this.employerRolesFetchState = fetchState;
        },
        setPartnerRoles (roles: UserRoleModel[]) {
            this.partnerRoles = [ ...roles ];
        },
        setEmployerRoles (roles: UserRoleModel[]) {
            this.employerRoles = [ ...roles ];
        },
        getEmployerRoles () {
            return new Promise<void>((resolve, reject) => {
                if (this.employerRolesFetchState === FetchState.Loading || this.employerRoles.length !== 0) {
                    resolve();
                    return;
                } else {
                    this.setEmployerRolesFetchState(FetchState.Loading);
                    return getRolesByType(RoleType.Employer).then(resp => {
                        this.setEmployerRoles(resp.data);
                        this.setEmployerRolesFetchState(FetchState.Loaded);
                    }).catch(err => {
                        storeHelper.handleError({ error: err, rethrow: true });
                    });
                }
            });
        },
        getPartnerRoles () {
            return new Promise<void>((resolve, reject) => {
                if (this.partnerRolesFetchState === FetchState.Loading || this.partnerRoles.length !== 0) {
                    resolve();
                    return;
                } else {
                    this.setPartnerRolesFetchState(FetchState.Loading);
                    return getRolesByType(RoleType.Partner).then(resp => {
                        this.setPartnerRoles(resp.data);
                        this.setPartnerRolesFetchState(FetchState.Loaded);
                    }).catch(err => {
                        storeHelper.handleError({ error: err, rethrow: true });
                    });
                }
            });
        }
    }
});
